// packages/observability/src/correlation.ts
//
// Cross-system join keys. Atriam runs two telemetry systems (SigNoz for
// logs/traces, PostHog for exceptions+replay+analytics). They must share a
// correlation id so a PostHog issue links to its SigNoz trace and vice versa.
//
// Server- and client-safe — depends only on @opentelemetry/api.

import {
  trace,
  context as otelContext,
  isSpanContextValid,
} from "@opentelemetry/api";

export interface TraceContext {
  trace_id: string;
  span_id: string;
}

/**
 * Returns the current OTel trace/span id pair, or undefined if no span is
 * active or the span context is invalid (zero trace_id, zero span_id, etc.).
 * Attach to PostHog capture properties so the issue can be pivoted to its
 * SigNoz trace.
 */
export function getActiveTraceContext(): TraceContext | undefined {
  const span = trace.getSpan(otelContext.active());
  if (!span) {
    return undefined;
  }
  const sc = span.spanContext();
  if (!isSpanContextValid(sc)) {
    return undefined;
  }
  return { trace_id: sc.traceId, span_id: sc.spanId };
}
